import React from 'react';
import styles from './TableHeader.module.css';

const TableHeader = () => (
  <section className={styles['table-header']}>
    <p className={styles.header}>Your Top Performing Content</p>
    <a
      className={styles.button}
      href="https://publisher.fewcents.co/"
      target="_blank"
      rel="noreferrer"
    >
      See detailed Metrics
    </a>
  </section>
);

export default TableHeader;
